// extracted by mini-css-extract-plugin
export default {"zoomModal":"R0-z","image":"S0-z","button":"T0-z","isOverlayShown":"U0-z"};